import React from "react";
import {Divider} from "antd";

interface Props {
    imageURL : string
}


const Dividers : React.FC<Props> = ({imageURL}) => {

    return (
        <div className={"public-container"}>
            <div className={"divider-section"}>
                <Divider>
                    <img width={60} height={60} src={imageURL} alt={""} />
                </Divider>
            </div>
        </div>
    )
}

export default React.memo(Dividers)